import { ListGroup, Badge } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../styles/Chapters.css';
import { useProject } from "../../hooks/useProject";
import { useState } from "react";

import { FaCheck } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import { TbBrandStackshare } from "react-icons/tb";
import { MdDeleteOutline } from "react-icons/md";
import { CiEdit } from "react-icons/ci";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";


export default function ChapterItem({
chapter,
editingIndex,
setEditingIndex,
index,
onDelete,
minWords,
onShare,
project,
updateProject

}) {
const [tempTitle, setTitle] = useState("");
const chapterID = chapter.chapterID;

const { attributes, listeners, setNodeRef, transform, transition, setActivatorNodeRef } =
useSortable({ id: chapter.chapterID });

const style = {
    transition,
    transform: CSS.Transform.toString(transform),
  };

const handleTitleChange=()=>{
    const updatedChapters = [...project.chapters];
    updatedChapters[index].title = tempTitle;
    updateProject({ ...project, chapters: updatedChapters });
    setEditingIndex(null);
}

const handleEditClick=(index)=>{
    setTitle(project.chapters[index].title);
    setEditingIndex(index);
}

return(

        <div ref={setNodeRef} style={style}  
        className="d-flex justify-content-between align-items-center list-group-item my-1 p-3 border rounded">
            <div ref={setActivatorNodeRef} {...listeners} {...attributes} className="me-3" style={{cursor: 'grab'}}>
                ☰
            </div>
                <div className="ms-2 me-auto">
                    {editingIndex === index ? (
                        <div className="fw-bold">
                        <input 
                            type='text'
                            value={tempTitle}
                            onChange={(e) => setTitle(e.target.value) }
                        />
                        <FaCheck onClick={handleTitleChange} className='EditChapterIcon'/>
                        <IoClose onClick={() => setEditingIndex(null)} className='EditChapterIcon'/> 
                        </div>
                    ) : (
                        <div className="fw-bold" style={{fontFamily: 'Fredoka'}}>{chapter.title} 
                            <CiEdit onClick={() => handleEditClick(index)} style={{cursor: 'pointer'}}/>
                            <MdDeleteOutline onClick={onDelete} style={{cursor: 'pointer'}}/>
                            <TbBrandStackshare onClick={onShare}/>
                        </div>
                    )}
                </div>
            <Badge bg={chapter.words >=  minWords ? "success" : "danger"} pill>
                {chapter.words}
            </Badge>
        </div>

)
}